import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/polystore/client/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/polystore/client/layouts/default.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/app/polystore/client/layouts/landing.vue").then(m => m.default || m)),
  onboarding: defineAsyncComponent(() => import("/app/polystore/client/layouts/onboarding.vue").then(m => m.default || m))
}